import React from 'react'
import LikeButton from './LikeButton'
import Comments from './Comments'

const SocialInteractions = ({ event, currentUserId }) => {
  return (
    <div className="p-6 border-t border-white/10 space-y-4">
      <div className="flex items-center gap-4">
        <LikeButton
          eventId={event._id}
          initialLikes={event.likes || []}
          currentUserId={currentUserId}
        />
      </div>

      <Comments
        eventId={event._id}
        initialComments={event.comments || []}
        currentUserId={currentUserId}
        eventOwnerId={event.createdBy._id}
      />
    </div>
  )
}

export default SocialInteractions